import type { SITE_MODULATORS_COUNT_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-modulators-count-card/site-modulators-count-card.fr.ts";

export const SITE_MODULATORS_COUNT_CARD_ENGLISH_LOCALE = {
  title: "Modulators",
  subtitle: "On site",
  seeMore: "See more",
} satisfies typeof SITE_MODULATORS_COUNT_CARD_FRENCH_LOCALE;
